// components/system/StatusCard.jsx
import React from 'react';
import { formatTimestamp, formatNumber, getRefreshStatusIcon } from '../../utils/systemUtils';

const StatusCard = ({ title, status, value, timestamp, details, color = 'blue', icon = null }) => {
    const getStatusColor = () => {
        switch (color) {
            case 'green': return 'border-green-200 bg-green-50';
            case 'yellow': return 'border-yellow-200 bg-yellow-50';
            case 'orange': return 'border-orange-200 bg-orange-50';
            case 'red': return 'border-red-200 bg-red-50';
            case 'blue': return 'border-blue-200 bg-blue-50';
            default: return 'border-gray-200 bg-gray-50';
        }
    };

    const getTextColor = () => {
        switch (color) {
            case 'green': return 'text-green-800';
            case 'yellow': return 'text-yellow-800';
            case 'orange': return 'text-orange-800';
            case 'red': return 'text-red-800';
            case 'blue': return 'text-blue-800';
            default: return 'text-gray-800';
        }
    };

    const statusIcon = status ? getRefreshStatusIcon(status) : null;

    return (
        <div className={`border rounded-lg p-4 ${getStatusColor()}`}>
            <div className="flex items-start justify-between">
                <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-2">
                        {icon && <span className="text-lg">{icon}</span>}
                        <h3 className={`font-semibold ${getTextColor()}`}>{title}</h3>
                        {statusIcon && (
                            <span className="text-sm" title={status}>
                                {statusIcon.icon}
                            </span>
                        )}
                    </div>
                    
                    {value !== undefined && value !== null && (
                        <div className={`text-2xl font-bold ${getTextColor()} mb-1`}>
                            {formatNumber(value)}
                        </div>
                    )}
                    
                    {timestamp && (
                        <div className="text-xs text-gray-600 mb-2">
                            Last updated: {formatTimestamp(timestamp)}
                        </div>
                    )}
                    
                    {details && (
                        <div className="text-sm text-gray-700">
                            {Array.isArray(details) ? (
                                <ul className="space-y-1">
                                    {details.map((detail, index) => (
                                        <li key={index} className="flex items-center space-x-2">
                                            <span className="w-1 h-1 bg-gray-400 rounded-full"></span>
                                            <span>{detail}</span>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <span>{details}</span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatusCard;
